import { IRootState } from '../../../store'
import { IValidationState } from '../store/validation.types'

export const getValidationSelector = (state: IRootState): IValidationState => state.validation
